<template>
  <b-container class="p-3" fluid>
    <b-card v-if="$auth.user().role === 'coordinator' && project.status === 'DraftForCloseProjectApproval'" class="mb-2">
      <b-card-title>
        <b-row><b-col>แบบสอบถามความพึงพอใจ</b-col></b-row>
      </b-card-title>
      <div v-if="!project.event">
        <div class="b-col text-center text-secondary py-5">
          <font-awesome-icon :icon="['fa','ban']" size="6x" />
          <h4 class="py-4">ยังไม่ได้สร้างกิจกรรม</h4>
        </div>
      </div>
      <div v-else>
        <div class="b-col text-start text-secondary pt-2 pb-4">
          <b-card-title class="ml-3">
            <font-awesome-icon icon="users" />
            นำเข้าจากระบบทรานสคริปกิจกรรม
          </b-card-title>
          <div style="flex-grow: 1" class="mb-3 ml-3">
            สำหรับดึงข้อมูลจากระบบทรานสคริปกิจกรรม<br>
            <small class="text-muted">ฟังก์ชั่นนี้จะใช้ได้เฉพาะกิจกรรมที่ถูกสร้างผ่านระบบขออนุมัติฯเท่านั้น</small>
          </div>
          <button class="btn btn-primary" @click="submit">ดึงข้อมูลจากระบบจัดการกิจกรรม</button>
        </div>
      </div>
    </b-card>
    <b-card v-if="project.event">
      <satisfaction-chart
        v-for="satisfaction in project.satisfactionCharts"
        :key="satisfaction.orders"
        :satisfaction-detail="satisfaction"
        @printed="saveImages"
      />
    </b-card>
  </b-container>
</template>
<script>
import gql from 'graphql-tag'
import SatisfactionChart from '@/components/project/SatisfactionChart'
export default {
  components: { SatisfactionChart },
  data () {
    return {
      printedImages: []
    }
  },
  computed: {
    project () { return this.$store.getters['project/getProject'](this.$route.params.id) }
  },
  methods: {
    async submit () {
      await this.$apollo.mutate({
        mutation: gql`mutation($id: ID!) { projectGetSatisfactionCharts(id: $id) {satisfactionCharts} }`,
        variables: { id: this.$route.params.id }
      })
      this.$store.dispatch('project/fetchProject', this.$route.params.id)
    },
    saveImages (data) {
      this.printedImages.push(data)
      if (this.printedImages.length === this.project.satisfactionCharts.length) {
        this.$apollo.mutate({
          mutation: gql`mutation($id:ID!,$charts:[ChartImageBase64!]!){projectSaveSatisfactionChartsFromClient(id:$id,charts:$charts){id}}`,
          variables: { id: this.$route.params.id, charts: this.printedImages }
        })
        this.$store.dispatch('project/fetchProject', this.$route.params.id)
      }
    }
  }
}
</script>
